module.exports = __webpack_public_path__ + "static/media/Google_Play_Store.2b68356d.webp";